import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ibFix',
})
export class IbFixPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    const splitValue = this.split(value);

    return `${this.singleDigitRound(splitValue.numeric)}${this.convertUnit(
      splitValue.nonnumeric
    )}`;
  }

  singleDigitRound(number) {
    return Math.round(number * 10) / 10;
  }

  split(input) {
    // match only digits and decimal points in the first group and match the rest of the string in second group
    const splitArray = input.match(/([\d\.]+)(.*)/);

    return {
      numeric: splitArray[1],
      nonnumeric: splitArray[2],
    };
  }

  convertUnit(unit) {
    let newUnit;
    // reference: https://en.wikipedia.org/wiki/Kibibyte
    switch (unit) {
      case 'YiB':
        newUnit = ' YB';
        break;
      case 'ZiB':
        newUnit = ' ZB';
        break;
      case 'EiB':
        newUnit = ' EB';
        break;
      case 'PiB':
        newUnit = ' PB';
        break;
      case 'TiB':
        newUnit = ' TB';
        break;
      case 'GiB':
        newUnit = ' GB';
        break;
      case 'MiB':
        newUnit = ' MB';
        break;
      case 'KiB':
        newUnit = ' KB';
        break;

      default:
        newUnit = unit;
        break;
    }

    return newUnit;
  }
}
